import React, { Component } from "react";
import { connect } from "react-redux";
import { forgotPassword } from "../../../redux/actions";
import { Link } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { FirebaseContext } from "../../../firebase";
import { MailOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import Logo from "../../../logo.png";

const { Title } = Typography;

class Reset extends React.Component {
  state = { email: "", password: "" };

  render() {
    return (
      <FirebaseContext.Consumer>
        {(firebase) => {
          return (
            <div className="login-wrapper">
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={(values) =>
                  this.props.forgotPassword(firebase, values.email)
                }
              >
                <img src={Logo} className="login-logo"></img>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Пожалуйста, введите адрес электронной почты!",
                    },
                    {
                      type: "email",
                      message:
                        "Пожалуйста, введите действующий адрес электронной почты!",
                    },
                  ]}
                  className="login-password"
                >
                  <Input
                    prefix={<MailOutlined className="site-form-item-icon" />}
                    placeholder="Адрес электронной почты"
                  />
                </Form.Item>

                <Form.Item className="login-password">
                  <Link
                    className="login-form-forgot login-text-blue"
                    href=""
                    to="/auth/register"
                  >
                    Зарегистрироваться
                  </Link>
                  <Link href="" className="login-text-blue" to="/auth">
                    Войти
                  </Link>
                </Form.Item>
                {this.props.authError ? (
                  <p className="auth-error">{this.props.authError.message}</p>
                ) : null}
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button login-button-blue"
                  >
                    Отправить
                  </Button>
                </Form.Item>
              </Form>
            </div>
          );
        }}
      </FirebaseContext.Consumer>
    );
  }
}

const mapStateToProps = (state) => ({ authError: state.authError });

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (firebase, email) =>
      dispatch(forgotPassword(firebase, email)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reset);
